"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReplaceSubscriptionData = void 0;
var _react = require("react");
var _context = require("../../context");
const useReplaceSubscriptionData = () => (0, _react.useContext)(_context.replaceSubscriptionDataContext);
exports.useReplaceSubscriptionData = useReplaceSubscriptionData;